// Data-access selector (S3). Routes ALL data access through one of the
// providers and picks the backend from a single build-time env var.
// See docs/features/supabase/.
//
// Static imports (not dynamic import()) so Vite can tree-shake the unused
// provider out of the production bundle: the chosen VITE_DATA_PROVIDER is
// fixed at build time (a Netlify env var per deploy), there's no runtime
// backend switching. Both provider barrels are side-effect-free (each reaches
// its SDK lazily), so statically importing the dead one constructs nothing.
import * as firebaseProvider from './firebase/index.js';
import * as supabaseProvider from './supabase/index.js';

const name = (import.meta.env?.VITE_DATA_PROVIDER || 'firebase').toLowerCase();

const providers = { firebase: firebaseProvider, supabase: supabaseProvider };
const provider = providers[name];
if (!provider) {
  throw new Error(
    `Unknown VITE_DATA_PROVIDER "${name}". Expected 'firebase' or 'supabase'.`,
  );
}

// Re-export the FULL contract surface (see ./contract.js) so shims and
// consumers pull every name from here.
export const {
  // Messages + reactions + attachments
  subscribeMessages,
  sendMessage,
  sendCodeSnippet,
  sendFileMessage,
  toggleReaction,
  listMyRooms,
  MAX_DISTINCT_REACTIONS,
  // Presence
  joinPresence,
  heartbeat,
  leavePresence,
  subscribePresence,
  PRESENCE_ACTIVE_MS,
  PRESENCE_HEARTBEAT_MS,
  // Typing
  startTyping,
  stopTyping,
  subscribeTyping,
  TYPING_TTL_MS,
  // Party probe
  validatePartyExists,
  DEFAULT_PARTY,
  // Beam WebRTC signaling
  sendSignal,
  subscribeIncoming,
  deleteSignal,
  // File transfer + capabilities
  uploadFile,
  getFileUrl,
  deleteFile,
  capabilities,
  // Provider-agnostic shapes/helpers
  normalizeMessage,
  sortKey,
  newMessageId,
} = provider;
